import * as RadixSwitch from '@radix-ui/react-switch';
import clsx from 'clsx';
import { useId } from 'react';
import styles from './Switch.module.css';

export interface SwitchProps {
  readonly label: string;
  readonly description?: string | undefined;
  readonly checked: boolean;
  readonly onCheckedChange: (checked: boolean) => void;
  readonly disabled?: boolean | undefined;
  readonly className?: string | undefined;
}

/** On/off setting: label on the start side, the switch at the end. */
export const Switch = ({
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
  className,
}: SwitchProps) => {
  const id = useId();
  return (
    <div className={clsx(styles.row, disabled && styles.disabled, className)}>
      <label className={styles.text} htmlFor={id}>
        <span className={styles.label}>{label}</span>
        {description && <span className={styles.description}>{description}</span>}
      </label>
      <RadixSwitch.Root
        id={id}
        className={styles.switch}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled ?? false}
      >
        <RadixSwitch.Thumb className={styles.thumb} />
      </RadixSwitch.Root>
    </div>
  );
};
